export default __webpack_public_path__ + "static/freehand-f8b7feb0b5c79add727176b285de3ddb.gif";